import { styled } from '@stitches/configed';
import { useState } from 'react';
import Layout from './Layout';
// import Button from '../Common/Button'
import { Button, Divider, } from 'antd';
import { useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import Form, { Field } from '../Common/Form';
import WarningIcon from '../Common/Icons/WarningIcon';
import Input from '../Common/Input';
import ModalDialog from '../Common/Modal/ModalDialog';

export const Title = styled('h4', {
  uTextSize: 'lg',
  fontWeight: 600,
  textAlign: 'center',
  marginBottom: '1rem',
});

export const SubmitButton = styled(Button, {
  width: '100%',
  height: 52,
});
export const ForgotPasswordText = styled('div', {
  marginTop: 32,
  color: '$link',
  cursor: 'pointer',
});
const RegisterRow = styled('div', {
  textAlign: 'center',
  fontWeight: 600,
});
export const LinkStyled = styled('span', {
  color: '$link',
  cursor: 'pointer',
});

type LoginParams = {
  account: string;
  password: string;
  firebaseToken: string;
};
type Props = {
  onSubmit: (value: LoginParams) => void;
  isSubmiting: boolean;
  errorMessage?: string;
  clearMessage?: () => void;
  showLinkRegister?: boolean;
  showLinkForgotPassword?: boolean;
  currentEmail?: string;
};
export default function Login({
  onSubmit,
  isSubmiting,
  errorMessage,
  clearMessage,
  showLinkRegister,
  showLinkForgotPassword,
  currentEmail
}: Props) {
  const [showPass, setShowPass] = useState(false);
  const navigate = useNavigate();

  const onFinish = (value: any) => {
    onSubmit(value);
  };
  return (
    <Layout>
      <ModalDialog
        visible={errorMessage ? true : false}
        type="warning"
        icon={<WarningIcon />}
        heading={errorMessage}
        onClose={clearMessage}
        confirm={false}
      />
      <Form layout="vertical" onFinish={onFinish} validateTrigger="onSubmit" >
        <Title>Đăng nhập tài khoản</Title>
        <Field
          hidden
          name="firebaseToken"
          initialValue={localStorage.getItem('firebaseToken') || uuidv4()}
        >
          <Input />
        </Field>
        <Field
          label="Email"
          name="email"
          rules={[
            { required: true, message: 'Vui lòng nhập email!' },
            { type: 'email', message: 'Email sai định dạng' },
          ]}
          initialValue={currentEmail}
        >
          <Input placeholder="Nhập email" />
        </Field>
        <Field
          label="Mật khẩu"
          name="password"
          rules={[{ required: true, message: 'Vui lòng nhập mật khẩu!' }]}
        >
          <Input
            placeholder="Nhập mật khẩu"
            type={showPass ? 'text' : 'password'}
          />
        </Field>
        <Field>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <LinkStyled onClick={() => setShowPass(!showPass)}>
              {showPass ? 'Ẩn' : 'Hiện'} mật khẩu
            </LinkStyled>
            {showLinkForgotPassword && (
              <LinkStyled onClick={() => navigate('/forgot-password')}>
                Quên mật khẩu đăng nhập
              </LinkStyled>
            )}
          </div>
        </Field>
        <Field>
          <Button type="primary" htmlType="submit" block loading={isSubmiting}>
            Đăng nhập
          </Button>
        </Field>
        {showLinkRegister && (
          <>
            <Divider
              style={{ fontWeight: 400, fontSize: 14, margin: '32px 0 8px' }}
            >
              Chưa có tài khoản?
            </Divider>
            <RegisterRow>
              <LinkStyled onClick={() => navigate('/register')}>
                Đăng ký ngay
              </LinkStyled>
            </RegisterRow>
          </>
        )}
      </Form>
    </Layout>
  );
}


